export default "__VITE_ASSET__Ky2kTI5R__"